import React from 'react';
import { motion } from 'framer-motion';
import GlowCard from '../components/UI/GlowCard';
import Button from '../components/UI/Button';
import { celebrateSmall } from '../components/UI/confetti';

export default function RoomJoin() {
  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="pt-24 pb-24 md:pb-8 px-4 md:pl-56 space-y-6">
      <h1 className="text-white text-2xl font-bold">Join a Room</h1>
      <GlowCard className="p-5 max-w-xl">
        <label className="block text-white/80 text-sm mb-2">Room Code</label>
        <input className="w-full rounded-xl bg-white/5 border border-white/10 px-4 py-3 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-royal/60" placeholder="Enter room code" />
        <div className="mt-4 flex gap-3">
          <Button variant="royal" onClick={celebrateSmall}>Join</Button>
          <Button variant="success">Random</Button>
        </div>
      </GlowCard>
    </motion.div>
  );
}
